import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'

import TeamSystemIntegrationContent from './TeamSystemIntegrationContent'

const TeamSystemIntegration = () => {
  return (
    <PayrollPaywallGuard>
      <TeamSystemIntegrationContent />
    </PayrollPaywallGuard>
  )
}

export default TeamSystemIntegration
